import { request } from './_request.js';
import type {
  MyEvaluationTasksResponse,
  SubmitEvaluationAnswerInput,
  SubmitEvaluationAnswerResponse,
} from '../../types/idt-design-evaluation.js';

/**
 * デザイナー貢献度アンケート API クライアント。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business デザイナー貢献度アンケートの未回答タスク取得と回答登録を行う API クライアント
 * @graph-connects /idt-design-evaluation/my-tasks [calls, via:GET] 自分が回答すべきアンケート一覧を取得
 * @graph-connects /idt-design-evaluation/answers [calls, via:POST] アンケート回答を登録
 */
export const idtDesignEvaluationApi = {
  /** 自分が PL / 主担当である評価対象を未回答優先で取得する。 */
  getMyTasks: async (): Promise<MyEvaluationTasksResponse> =>
    request<MyEvaluationTasksResponse>('/idt-design-evaluation/my-tasks'),

  /** アンケート回答を登録する（1 子チケットにつき 1 回のみ）。 */
  submitAnswer: async (
    payload: SubmitEvaluationAnswerInput,
  ): Promise<SubmitEvaluationAnswerResponse> =>
    request<SubmitEvaluationAnswerResponse>('/idt-design-evaluation/answers', {
      method: 'POST',
      body: JSON.stringify(payload),
    }),
};
